import React from "react";
import ReportData from "../component/reportData";

function ReportDataContainer() {
  return <ReportData />;
}

export default ReportDataContainer;
